import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=c8adeb92&scoped=true&"
import script from "./BulkUpload.vue?vue&type=script&setup=true&lang=js&"
export * from "./BulkUpload.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=c8adeb92&prod&lang=scss&scoped=true&"
import style1 from "./BulkUpload.vue?vue&type=style&index=1&id=c8adeb92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8adeb92",
  null
  
)

export default component.exports